document.addEventListener('click', function(e) {
  if (e.target.matches('[data-action="show-pre-order-modal"]')) {
      e.preventDefault();
      const modal = document.getElementById('pre-order-modal');
      
      // Add null check for modal
      if (!modal) return;
      
      // Move modal to be direct child of body
      if (modal.parentElement !== document.body) {
          document.body.appendChild(modal);
      }
      
      // Force modal to be visible with higher z-index
      modal.style.cssText = `
          display: flex !important;
          visibility: visible !important;
          opacity: 1 !important;
          z-index: 2147483648 !important;
          position: fixed !important;
          top: 0 !important;
          left: 0 !important;
          right: 0 !important;
          bottom: 0 !important;
          background: rgba(0, 0, 0, 0.5) !important;
          align-items: center !important;
          justify-content: center !important;
          pointer-events: auto !important;
          overflow: auto !important;
      `;
  }

  // Add new handler for size chart modal
  if (e.target.closest('[data-action="open-size-chart-modal"]')) {
    e.preventDefault();
    const modalId = e.target.closest('[data-action="open-size-chart-modal"]').getAttribute('aria-controls');
    const modal = document.getElementById(modalId);
    
    // Add null check for modal
    if (!modal) return;
    
    // Move modal to be direct child of body
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }
    
    // Force modal to be visible with higher z-index
    modal.style.cssText = `
      display: flex !important;
      visibility: visible !important;
      opacity: 1 !important;
      z-index: 2147483648 !important;
      position: fixed !important;
      top: 0 !important;
      left: 0 !important;
      right: 0 !important;
      bottom: 0 !important;
      background: rgba(0, 0, 0, 0.5) !important;
      align-items: center !important;
      justify-content: center !important;
      pointer-events: auto !important;
      overflow: auto !important;
    `;
  }

  // Handle closing both modals
  if (e.target.matches('[data-action="close-modal"]') ||
      (e.target.classList.contains('size-chart-modal') && !e.target.closest('.size-chart-modal__content')) ||
      (e.target.classList.contains('pre-order-modal') && !e.target.closest('.pre-order-modal__content'))) {
    e.preventDefault();
    const modal = e.target.closest('.size-chart-modal') || e.target.closest('.pre-order-modal');
    if (modal) {
      closeModal(modal);
    }
  }
});

// Remove any existing event listeners
document.removeEventListener('click', handleDocumentClick, true);

// Add event listener at document level with capture phase
document.addEventListener('click', handleDocumentClick, true);

function handleDocumentClick(e) {
    // Handle pre-order modal button
    if (e.target.matches('[data-action="confirm-pre-order"]')) {
        e.preventDefault();
        e.stopPropagation();
        
        const modal = e.target.closest('.pre-order-modal');
        if (!modal) return;
        
        // Find the active product form
        const productForm = document.querySelector('form[action="/cart/add"]');
        if (productForm) {
            // Get the currently selected variant ID
            const selectedVariant = productForm.querySelector('input[name="id"]:checked, select[name="id"]').value;
            
            // Create FormData and ensure the correct variant ID is set
            const formData = new FormData(productForm);
            formData.set('id', selectedVariant);
            
            // Close the modal
            closeModal(modal);
            
            document.dispatchEvent(new CustomEvent("theme:loading:start"));
            
            // Submit the form via fetch
            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                body: formData,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            })
            .then(response => {
                if (!response.ok) {
                    document.dispatchEvent(new CustomEvent("theme:loading:end"));
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                document.documentElement.dispatchEvent(new CustomEvent('product:added', {
                    bubbles: true,
                    detail: {
                        variant: data,
                        quantity: formData.get('quantity') || 1
                    }
                }));
                if (window.theme.cartType === "drawer") {
                  document.dispatchEvent(new CustomEvent("modal:close"));
                }
            })
            .catch(error => {
                console.error('Error:', error);
            });
        }
    }
    
    // Handle closing modal
    if (e.target.matches('[data-action="close-modal"]') ||
        (e.target.classList.contains('pre-order-modal') && !e.target.closest('.pre-order-modal__content'))) {
        e.preventDefault();
        const modal = e.target.closest('.pre-order-modal');
        if (modal) {
            closeModal(modal);
        }
    }
}

// Function to close modal and reset overflow
function closeModal(modal) {
  modal.style.cssText = 'display: none !important;';
  document.body.style.overflow = ''; // Reset overflow property
}